// extracted by mini-css-extract-plugin
export var borderRadius = "_cx-4";
export var large = "_cx-3";
export var logoContainer = "_cx-0";
export var nameLogo = "_cx-2";
export var small = "_cx-1";